import React from 'react';
import { useLocation } from 'react-router-dom';
import useLinks from './hooks/useLinks';
import NavItem from '../nav-item/NavItem';

const MenuLinks: React.FC<unknown> = () => {
  const { getLinks } = useLinks();
  const location = useLocation();

  return (
    <div>
      <ul className="p-0 m-0 list-none">
        {getLinks().map((link) => (
          <NavItem
            to={link.to}
            icon={link.icon}
            label={link.label}
            image={link.image}
            key={link.label}
            isHighlighted={link.isHighlighted}
            pathname={location.pathname}
          />
        ))}
      </ul>
    </div>
  );
};

export default MenuLinks;
